import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { ProgressIndicatorService } from '../misc/progress-indicator.service';

@Injectable()
export class ProgressIndicatorInterceptor implements HttpInterceptor {

  constructor(private requestCount: ProgressIndicatorService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.requestCount.increment();

    return next.handle(req).pipe(
      finalize(() => {
        this.requestCount.decrement();
      })
    );
  }
}
